import Vue from "vue";
import set from "lodash/set";
import get from "lodash/get";
import state from "../../store/state";
import { typologyTagging } from "@/utils/helpers";
import {
  AdobeFunctions,
  _normalizeCharacters
} from "@/pixels/providers/utils/adobeFunctions";

const pageName = _BBVA_MOTOR === "ofertaHipotecarios" ? "1 datos" : "1 inicio";

const Adobe = {
  enable() {},
  wait() {
    return !!window._satellite && !!(document.readyState === "complete");
  },
  init(context) {
    AdobeFunctions.internal(context, () => {
      Vue.$log.info("🚀 Adobe Launch working");
    });
  },
  appStartedClick(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setTypology();
      AdobeFunctions.setApplicationProps();
      AdobeFunctions.setPageName(pageName);
      AdobeFunctions.setProductAttributes(context);
      set(
        window.digitalData,
        "application.step",
        _normalizeCharacters(context.mutation.payload)
      );

      if (_BBVA_MOTOR === "ofertaHipotecarios") {
        set(window.digitalData, "page.pageInfo.pageSegment", "personas");
        set(window.digitalData, "page.pageInfo.projectName", "Open Market");
        set(
          window.digitalData,
          "page.pageInfo.level1",
          "simulador hipotecario"
        );
        set(window.digitalData, "page.pageInfo.level2", "1 datos");
        set(
          window.digitalData,
          "application.typology",
          "segun valor de la vivienda"
        );
      }

      set(
        window.digitalData,
        "page.pageInfo.pageIntent",
        _BBVA_MOTOR === "ofertaHipotecarios" ? "informacion" : "transaccion"
      );

      AdobeFunctions.callAdobeDTM("digitalLink", "App Started");
    });
  },
  appOnClickStart(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setTypology();
      AdobeFunctions.setApplicationProps();
      AdobeFunctions.setCustomFields(context);
      AdobeFunctions.setPageName("2 simulador");
      AdobeFunctions.setProductAttributes(context);
      set(
        window.digitalData,
        "application.step",
        get(context.mutation.payload, "appStep", "")
      );
      set(window.digitalData, "page.pageInfo.pageIntent", "transaccion");

      if (_BBVA_MOTOR === "ofertaHipotecarios") {
        set(
          window.digitalData,
          "page.pageInfo.pageName",
          "escritorio:publica:personas:simulador credito hipotecario"
        );

        set(
          window.digitalData,
          "application.step",
          "simular credito monto de la vivienda"
        );
        set(
          window.digitalData,
          "page.pageInfo.pageName",
          "escritorio:publica:personas:simulador credito hipotecario"
        );
        set(
          window.digitalData,
          "page.pageInfo.level1",
          "simulador credito hipotecario"
        );
        set(window.digitalData, "page.pageInfo.pageSegment", "personas");
        set(window.digitalData, "page.pageInfo.pageIntent", "informacion");
        set(window.digitalData, "page.pageInfo.projectName", "Open Market");
      }

      AdobeFunctions.callAdobeDTM("digitalLink", "App On Click Start");
    });
  },
  hipotecarioPageVisit(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setApplicationProps();
      AdobeFunctions.setPageName("1 datos");
      AdobeFunctions.setHipotecariosDefaults();

      set(window.digitalData, "page.pageInfo.level1", "simulador hipotecario");

      set(window.digitalData, "page.pageInfo.level2", "1 datos");
      set(window.digitalData, "application.step", "1 datos");

      set(window.digitalData, "page.pageInfo.projectName", "Open Market");
      set(window.digitalData, "application.typology", "valor de la vivienda");

      AdobeFunctions.callAdobeDTM("digitalView", "App Page Visit");
    });
  },
  calculadoraValorStep2(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setApplicationProps();
      AdobeFunctions.setPageName("2 monto a solicitar");
      AdobeFunctions.setHipotecariosDefaults();

      set(window.digitalData, "page.pageInfo.level2", "2 monto a solicitar");
      set(window.digitalData, "application.step", "2 monto a solicitar");

      set(
        window.digitalData,
        "application.typology",
        "segun valor de la vivienda"
      );

      AdobeFunctions.callAdobeDTM("digitalView", "App Step 2");
    });
  },
  calculadoraValorStep3(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setApplicationProps();
      AdobeFunctions.setPageName("3 resultado simulacion");
      AdobeFunctions.setHipotecariosDefaults();

      set(window.digitalData, "page.pageInfo.level2", "3 resultado simulacion");
      set(window.digitalData, "application.step", "3 resultado simulacion");

      set(
        window.digitalData,
        "application.typology",
        "segun valor de la vivienda"
      );

      AdobeFunctions.callAdobeDTM("digitalView", "App Step 3");
    });
  },
  calculadoraValorStep4(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setApplicationProps();
      AdobeFunctions.setPageName("4 caracteristicas");
      AdobeFunctions.setHipotecariosDefaults();

      set(window.digitalData, "page.pageInfo.level2", "4 caracteristicas");
      set(window.digitalData, "application.step", "4 caracteristicas");

      set(
        window.digitalData,
        "application.typology",
        "segun valor de la vivienda"
      );

      AdobeFunctions.callAdobeDTM("digitalView", "App Step 4");
    });
  },
  calculadoraValorStep5(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setApplicationProps();
      AdobeFunctions.setPageName("5 datos de contacto");
      AdobeFunctions.setHipotecariosDefaults();

      set(window.digitalData, "page.pageInfo.level2", "5 datos de contacto");
      set(window.digitalData, "application.step", "5 datos de contacto");

      set(
        window.digitalData,
        "application.typology",
        "segun valor de la vivienda"
      );

      AdobeFunctions.callAdobeDTM("digitalView", "App Step 5");
    });
  },
  internalLink(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setPageName(get(context.mutation.payload, "level2", ""));
      set(
        window.digitalData,
        "page.pageActivity.link.name",
        get(context.mutation.payload, "name", "")
      );
      set(
        window.digitalData,
        "page.pageInfo.pageIntent",
        get(context.mutation.payload, "intent", "informacion")
      );
      AdobeFunctions.callAdobeDTM("digitalLink", "Internal Link");
    });
  },
  consulta(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setTypology();
      AdobeFunctions.setApplicationProps();
      AdobeFunctions.setPageName(pageName);
      AdobeFunctions.setProductAttributes(context);
      set(window.digitalData, "application.step", pageName);
      set(window.digitalData, "application.isQualifiedVisits", "true");
      set(window.digitalData, "page.pageInfo.pageIntent", "transaccion");
      if (_BBVA_MOTOR === "ofertaHipotecarios") {
        set(
          window.digitalData,
          "page.pageInfo.level1",
          "simulador hipotecario"
        );
        set(window.digitalData, "page.pageInfo.level2", "1 datos");
      }
      AdobeFunctions.callAdobeDTM("digitalView", "App Page Visit");
    });
  },
  oferta(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setTypology();
      AdobeFunctions.setApplicationProps();
      AdobeFunctions.setCustomFields(context);
      AdobeFunctions.setPageName("2 simulador");
      AdobeFunctions.setProductAttributes(context);
      set(window.digitalData, "application.step", "2 simulador");
      set(window.digitalData, "page.pageInfo.pageIntent", "transaccion");
      AdobeFunctions.callAdobeDTM("digitalView", "App Step 2");
    });
  },
  compruebaIdentidad(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setCustomFields(context);
      AdobeFunctions.setPageName(`landing qr ${typologyTagging()}`);
      AdobeFunctions.callAdobeDTM("digitalView", "Page View");
    });
  },
  paso1(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setTypology();
      AdobeFunctions.setApplicationProps();
      AdobeFunctions.setCustomFields(context);
      AdobeFunctions.setPageName("3 datos personales");
      AdobeFunctions.setProductAttributes(context, "contratacion");
      set(window.digitalData, "application.step", "3 datos personales");
      set(window.digitalData, "page.pageInfo.pageIntent", "transaccion");
      AdobeFunctions.callAdobeDTM("digitalView", "App Step 3");
    });
  },
  paso2(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setTypology();
      AdobeFunctions.setApplicationProps();
      AdobeFunctions.setCustomFields(context);
      AdobeFunctions.setPageName("4 datos laborales");
      AdobeFunctions.setProductAttributes(context, "contratacion");
      set(window.digitalData, "application.step", "4 datos laborales");
      set(window.digitalData, "page.pageInfo.pageIntent", "transaccion");
      AdobeFunctions.callAdobeDTM("digitalView", "App Step 4");
    });
  },
  paso3(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setTypology();
      AdobeFunctions.setApplicationProps();
      AdobeFunctions.setCustomFields(context);
      AdobeFunctions.setPageName("5 informacion adicional");
      AdobeFunctions.setProductAttributes(context, "contratacion");
      set(window.digitalData, "page.pageInfo.pageIntent", "transaccion");
      set(window.digitalData, "application.step", "5 informacion adicional");
      AdobeFunctions.callAdobeDTM("digitalView", "App Step 5");
    });
  },
  paso4(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setTypology();
      AdobeFunctions.setApplicationProps();
      AdobeFunctions.setPageName("6 validacion de identidad");
      AdobeFunctions.setProductAttributes(context, "contratacion");
      set(window.digitalData, "page.pageInfo.pageIntent", "transaccion");
      set(window.digitalData, "application.step", "6 validacion de identidad");
      AdobeFunctions.callAdobeDTM("digitalView", "App Step 6");
    });
  },
  loadingVeridas(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setTypology();
      AdobeFunctions.setApplicationProps();
      AdobeFunctions.setCustomFields(context);
      AdobeFunctions.setPageName("7 validando identidad");
      AdobeFunctions.setProductAttributes(context, "contratacion");
      set(window.digitalData, "page.pageInfo.pageIntent", "transaccion");
      set(window.digitalData, "application.step", "7 validando identidad");
      AdobeFunctions.callAdobeDTM("digitalView", "App Step 7");
    });
  },
  biometriaOK(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setTypology();
      AdobeFunctions.setApplicationProps();
      AdobeFunctions.setCustomFields(context);
      AdobeFunctions.setPageName("8 validacion exitosa");
      AdobeFunctions.setProductAttributes(context, "contratacion");
      set(window.digitalData, "page.pageInfo.pageIntent", "transaccion");
      set(window.digitalData, "application.step", "8 validacion exitosa");
      AdobeFunctions.callAdobeDTM("digitalView", "App Step 8");
    });
  },
  entrega(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setTypology();
      AdobeFunctions.setApplicationProps();
      AdobeFunctions.setCustomFields(context);
      AdobeFunctions.setPageName("9 domicilio entrega");
      AdobeFunctions.setProductAttributes(context, "contratacion");
      set(window.digitalData, "application.step", "9 domicilio entrega");
      set(window.digitalData, "page.pageInfo.pageIntent", "transaccion");
      AdobeFunctions.callAdobeDTM("digitalView", "App Step 9");
    });
  },
  resumen(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setTypology();
      AdobeFunctions.setApplicationProps();
      AdobeFunctions.setCustomFields(context);
      AdobeFunctions.setPageName("10 resumen");
      AdobeFunctions.setProductAttributes(context, "contratacion");
      set(window.digitalData, "application.step", "10 resumen");
      set(window.digitalData, "page.pageInfo.pageIntent", "transaccion");
      AdobeFunctions.callAdobeDTM("digitalView", "App Step 10");
    });
  },
  contratos(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setTypology();
      AdobeFunctions.setApplicationProps();
      AdobeFunctions.setCustomFields(context);
      AdobeFunctions.setPageName("11 contratos");
      AdobeFunctions.setProductAttributes(context, "contratacion");
      set(window.digitalData, "application.step", "11 contratos");
      set(window.digitalData, "page.pageInfo.pageIntent", "transaccion");
      AdobeFunctions.callAdobeDTM("digitalView", "App Step 11");
    });
  },
  gracias(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setTypology();
      AdobeFunctions.setApplicationProps();
      AdobeFunctions.setCustomFields(context);
      AdobeFunctions.setPageName("pagina exitosa");
      AdobeFunctions.setProductAttributes(context, "contratacion");
      AdobeFunctions.setProductState("contratado");
      set(window.digitalData, "application.state", "contratado");
      set(window.digitalData, "application.step", "pagina exitosa");
      set(window.digitalData, "page.pageInfo.pageIntent", "transaccion");
      set(
        window.digitalData,
        "application.operationNumber",
        state.entrega.numeroTramite
      );
      AdobeFunctions.callAdobeDTM("digitalView", "App Completed");
    });
  },
  continuaSucursal(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setTypology();
      AdobeFunctions.setApplicationProps();
      AdobeFunctions.setCustomFields(context);
      AdobeFunctions.setPageName("pagina exitosa");
      AdobeFunctions.setProductAttributes(context, "contratacion");
      AdobeFunctions.setProductState("en revision");
      set(window.digitalData, "application.state", "en revision");
      set(window.digitalData, "application.step", "pagina exitosa");
      set(window.digitalData, "page.pageInfo.pageIntent", "transaccion");
      set(
        window.digitalData,
        "user.segment.profile",
        "acercate a una sucursal"
      );
      AdobeFunctions.callAdobeDTM("digitalView", "App Completed");
    });
  },
  usuario(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setPageName("usuario y clave");
      AdobeFunctions.callAdobeDTM("digitalView", "Page View");
    });
  },
  celular(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setPageName("validacion celular");
      AdobeFunctions.callAdobeDTM("digitalView", "Page View");
    });
  },
  final(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setPageName("ya podes entrar a banca online");
      AdobeFunctions.callAdobeDTM("digitalView", "Page View");
    });
  },
  mensajeVeridas(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      switch (context.mutation.payload.params.mje) {
        case "error-tokenExpired":
        case "error-veridas-result":
        case "error-dni":
          AdobeFunctions.setPageName("error fotos");
          set(window.digitalData, "page.pageInfo.errorPage", "error fotos");
          AdobeFunctions.callAdobeDTM("digitalView", "Page View");
          break;
        case "error-inicio-veridas":
          AdobeFunctions.setPageName("error permisos");
          set(window.digitalData, "page.pageInfo.errorPage", "error permisos");
          AdobeFunctions.callAdobeDTM("digitalView", "Page View");
          break;
      }
    });
  },
  errorPage(context) {
    let error =
      _BBVA_MOTOR === "ofertaHipotecarios"
        ? context.mutation.payload.message
        : context.mutation.payload;
    switch (error) {
      case "RECHAZO_02":
      case "RECHAZO_07":
      case "RECHAZO_704":
      case "calificacionInvalida":
      case "rechazoAntecedentes":
      case "residenteTemporal":
      case "RECHAZO_703":
      case "RECHAZO_04":
      case "RECHAZO_05":
      case "RECHAZO_06":
      case "RECHAZO_08":
      case "RECHAZO_10":
      case "RECHAZO_11":
      case "RECHAZO_12":
      case "RECHAZO_13":
      case "RECHAZO_702":
      case "RECHAZO_03":
      case "RECHAZO_701":
      case "SIN_PRESTAMOS_DISPONIBLES":
        AdobeFunctions.internal(context, () => {
          AdobeFunctions.setPageName("error sin oferta");
          set(
            window.digitalData,
            "page.pageInfo.errorPage",
            "error sin oferta"
          );
          AdobeFunctions.callAdobeDTM("digitalView", "Page View");
        });
        break;
      case "individuoNegativo":
      case "datosIncorrectos":
      case "RECHAZO_F_02":
      case "RECHAZO_F_01":
      case "mensaje-7":
        AdobeFunctions.internal(context, () => {
          AdobeFunctions.setPageName("error oferta en curso");
          set(
            window.digitalData,
            "page.pageInfo.errorPage",
            "error oferta en curso"
          );
          AdobeFunctions.callAdobeDTM("digitalView", "Page View");
        });
        break;
      case "ERROR_SIMULACION_PH":
        AdobeFunctions.internal(context, () => {
          AdobeFunctions.setPageName("error realizar simulacion");
          set(
            window.digitalData,
            "page.pageInfo.errorPage",
            "error realizar simulacion"
          );
          set(
            window.digitalData,
            "page.pageInfo.level1",
            "simulador hipotecario"
          );
          set(
            window.digitalData,
            "page.pageInfo.level2",
            "error realizar simulacion"
          );
          set(window.digitalData, "page.pageInfo.pageIntent", "transaccion");
          AdobeFunctions.callAdobeDTM("digitalView", "Page View");
        });
        break;
      case "ERROR_CONFIRMACION_SIMULACION_PH":
        AdobeFunctions.internal(context, () => {
          AdobeFunctions.setPageName("error al cargar la informacion");
          set(
            window.digitalData,
            "page.pageInfo.errorPage",
            "error al cargar la informacion"
          );
          set(
            window.digitalData,
            "page.pageInfo.level1",
            "simulador hipotecario"
          );
          set(
            window.digitalData,
            "page.pageInfo.level2",
            "error al cargar la informacion"
          );
          set(window.digitalData, "page.pageInfo.pageIntent", "transaccion");
          AdobeFunctions.callAdobeDTM("digitalView", "Page View");
        });
        break;
      default:
        AdobeFunctions.internal(context, () => {
          AdobeFunctions.setPageName("error servicio");
          set(window.digitalData, "page.pageInfo.errorPage", "error servicio");
          AdobeFunctions.callAdobeDTM("digitalView", "Page View");
        });
    }
  },
  asesoramiento(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setCustomFields(context);
      AdobeFunctions.setPageName(`landing qr ${typologyTagging()}`);
      AdobeFunctions.callAdobeDTM("digitalView", "Page View");
    });
  },
  contacto(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setApplicationProps();
      AdobeFunctions.setPageName("2 datos personales");
      AdobeFunctions.setProductAttributes(context, "hipotecario");
      set(window.digitalData, "application.step", "2 datos personales");
      set(window.digitalData, "page.pageInfo.pageIntent", "transaccion");
      set(window.digitalData, "page.pageInfo.level1", "simulador hipotecario");
      AdobeFunctions.callAdobeDTM("digitalView", "App Step 2");
    });
  },
  graciasPH(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setApplicationProps();
      AdobeFunctions.setPageName("pagina exitosa");
      AdobeFunctions.setProductAttributes(context, "hipotecario");
      AdobeFunctions.setProductState("finalizado");
      set(window.digitalData, "page.pageInfo.pageSegment", "personas");
      set(window.digitalData, "page.pageInfo.level1", "simulador hipotecario");
      set(window.digitalData, "page.pageInfo.level2", "pagina exitosa");
      set(window.digitalData, "application.state", "finalizado");
      set(window.digitalData, "application.step", "pagina exitosa");
      set(window.digitalData, "page.pageInfo.pageIntent", "informacion");
      set(
        window.digitalData,
        "application.typology",
        "segun valor de la vivienda"
      );
      set(
        window.digitalData,
        "application.operationNumber",
        get(context, "state.entrega.numeroTramite", "")
      );
      set(
        window.digitalData,
        "products.attributes[0].productSubtype",
        "prestamos hipotecarios"
      );
      set(
        window.digitalData,
        "products.attributes[0].primaryCategory",
        "prestamos"
      );
      set(window.digitalData, "products.attributes[0].state", "finalizado");

      AdobeFunctions.callAdobeDTM("digitalView", "App Completed");
    });
  }
};

export default Adobe;
